var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app__container"},[(_vm.loading)?_c('div',{staticClass:"app__loading"},[_c('p',[_vm._v("Warming up")]),_c('LoadingIcon')],1):_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }